import LocationOnIcon from '@mui/icons-material/LocationOn';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import {
  RootDiv,
  TitleTypography,
  DivisionLine,
  AddressDiv,
  AddAddressIconButton,
  AddressTypographyDiv,
  AddressTypographyTitle,
  AddressTypographySubTitle,
  InfoDiv,
  InfoIconButton,
  InfoTypography,
} from '../styles/Delivery&PickUpContainer.styles';

export function PickUpContainer() {
  return (
    <>
      <RootDiv missingInfo={false}>
        <TitleTypography>Dirección de retiro</TitleTypography>
        <DivisionLine />
        <AddressDiv>
          <AddAddressIconButton>
            <LocationOnIcon />
          </AddAddressIconButton>
          <AddressTypographyDiv>
            <AddressTypographyTitle>Farmacia Meki</AddressTypographyTitle>
            <AddressTypographySubTitle>
              Av. El Salto 4001, Local 8, Huechuraba
            </AddressTypographySubTitle>
            <AddressTypographySubTitle>
              Lunes a Viernes de 09:00 a 18:00 hrs
            </AddressTypographySubTitle>
          </AddressTypographyDiv>
        </AddressDiv>{' '}
        {/* Address Item */}
      </RootDiv>
      <InfoDiv>
        <InfoIconButton>
          <InfoOutlinedIcon />
        </InfoIconButton>
        <InfoTypography>
          Te enviaremos un correo cuando tu pedido esté listo para ser retirado
        </InfoTypography>
      </InfoDiv>
    </>
  );
}
